import { GridColumnProps } from "@roc/client-portal-shared/components";
import { formatCurrency, noOpComparator } from "@roc/ui/utils";

const usdAmount: any = params => {
  return params.value && formatCurrency(Number(params.value));
};

const DISPUTE_TASK_CODE_INTERNAL_ROV = 'Internal Valuation ROV for Appraisal';
const DISPUTE_TASK_CODE_CLIENT = 'Client Valuation Dispute';

export const internalReviewLoansColumns: GridColumnProps[] = [
  {
    field: 'priority',
    headerName: 'Priority',
    maxWidth: 140,
    comparator: noOpComparator,
    cellRenderer: 'priorityCellRenderer',
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'loanId',
    headerName: 'Loan Id',
    maxWidth: 110,
    cellRenderer: 'loanIdCellRenderer',
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'status',
    headerName: 'Status',
    minWidth: 150,
    cellRenderer: 'statusCellRenderer',
    comparator: noOpComparator,
    filter: 'selectFilter',
    floatingFilter: true,
    floatingFilterComponent: 'selectFloatingFilter',
    floatingFilterComponentParams: {
      suppressFilterButton: true,
      options: [
        { label: 'In Underwriting', value: 'IN_UNDERWRITING' },
        { label: 'Agreed', value: 'AGREED' },
        { label: 'Pending', value: 'PENDING' },
        { label: 'Pending Decision', value: 'PENDING_DECISION' },
        { label: 'Pending Term Sheet', value: 'PENDING_TERM_SHEET' },
        { label: 'Prescreen', value: 'PRESCREEN' },
        { label: 'Term Sheet Out', value: 'TERM_SHEET_OUT' },
        { label: 'Unknown', value: 'UNKNOWN' },
        { label: 'Pre-Submission', value: 'PENDING_SUBMISSION' },
        { label: 'Deal Room', value: 'DEAL_ROOM' },
      ],
    },
  },
  {
    field: 'subStatus',
    headerName: 'Sub Status',
    minWidth: 240,
    cellRenderer: 'subStatusCellRenderer',
    comparator: noOpComparator,
    filter: 'selectFilter',
    floatingFilter: true,
    floatingFilterComponent: 'selectFloatingFilter',
    floatingFilterComponentParams: {
      suppressFilterButton: true,
      options: [
        { label: 'Data Entry No Appraisal', value: 'DATA_ENTRY_NO_APPRAISAL' },
        { label: 'Data Entry Appraisal', value: 'DATA_ENTRY_APPRAISAL' },
        { label: 'Structuring', value: 'STRUCTURING' },
        { label: 'In Underwriting', value: 'UNDERWRITING' },
        { label: 'Pending Decision', value: 'PENDING_DECISION' },
      ]
    },
  },
  {
    field: 'valuationReviewer',
    headerName: 'Valuation Reviewer',
    minWidth: 250,
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'address',
    headerName: 'Address',
    minWidth: 300,
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'state',
    headerName: 'State',
    minWidth: 125,
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'propertyType',
    headerName: 'Property Type',
    minWidth: 135,
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'queueClassification',
    headerName: 'Queue Classification',
    minWidth: 180,
    comparator: noOpComparator,
    filter: 'selectFilter',
    floatingFilter: true,
    floatingFilterComponent: 'selectFloatingFilter',
    floatingFilterComponentParams: {
      suppressFilterButton: true,
      options: [
        { label: 'Standard', value: 'Standard' },
        { label: 'Complex', value: 'Complex' },
      ],
    },
  },
  {
    field: 'salesInZipDays',
    headerName: '# of Sales',
    minWidth: 130,
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'delay',
    headerName: 'Delay',
    minWidth: 200,
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'reason',
    headerName: 'Reason',
    minWidth: 200,
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'queueStartDate',
    headerName: 'Queue Start Date',
    minWidth: 200,
    comparator: noOpComparator,
    filter: 'agDateColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'borrowerName',
    headerName: 'Borrower Name',
    minWidth: 250,
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'transactionType',
    headerName: 'Transaction Type',
    minWidth: 200,
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'appraisalDate',
    headerName: 'Appraisal Received Date',
    minWidth: 200,
    comparator: noOpComparator,
    filter: 'agDateColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'appraisalPaidDate',
    headerName: 'Appraisal Paid Date',
    minWidth: 200,
    comparator: noOpComparator,
    filter: 'agDateColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'inUnderwritingDate',
    headerName: 'In Underwriting Start Date',
    minWidth: 200,
    comparator: noOpComparator,
    filter: 'agDateColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'city',
    headerName: 'City',
    minWidth: 125,
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'county',
    headerName: 'County',
    minWidth: 200,
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'propertyCount',
    headerName: 'Property Count',
    minWidth: 100,
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'underwriter',
    headerName: 'Underwriter',
    minWidth: 200,
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'appraiserName',
    headerName: 'Appraiser',
    minWidth: 200,
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'loanSubtype',
    headerName: 'Loan Subtype',
    minWidth: 250,
    comparator: noOpComparator,
    filter: 'selectFilter',
    floatingFilter: true,
    floatingFilterComponent: 'selectFloatingFilter',
    floatingFilterComponentParams: {
      suppressFilterButton: true,
      options: [
        { label: 'Fix and Flip Pro (1-4)', value: 'Fix and Flip Pro (1-4)' },
        { label: 'Fix and Flip (1-4)', value: 'Fix and Flip (1-4)' },
        { label: 'Groundup (1-4)', value: 'Groundup (1-4)' },
        { label: 'Stabilized Bridge', value: 'Stabilized Bridge' },
        { label: 'Rental Portfolios', value: 'Rental Portfolios' },
        { label: 'Single Property Rental', value: 'Single Property Rental' },
      ],
    },
  },
  {
    field: 'lenderName',
    headerName: 'Lender',
    minWidth: 250,
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'amount',
    headerName: 'Loan Amount',
    minWidth: 150,
    valueFormatter: usdAmount,
    comparator: noOpComparator,
  },
  {
    field: 'afterRepairValue',
    headerName: 'ARV',
    minWidth: 150,
    valueFormatter: usdAmount,
    comparator: noOpComparator,
  },
  {
    field: 'actions',
    headerName: 'Actions',
    maxWidth: 100,
    cellRenderer: 'actionsCellRenderer',
    comparator: noOpComparator,
    pinned: 'right'
  },
];

export const rentalRiskReviewColumns: GridColumnProps[] = [
  {
    field: 'loanId',
    headerName: 'Loan Id',
    maxWidth: 110,
    cellRenderer: 'loanIdCellRenderer',
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'phase',
    headerName: 'Phase',
    maxWidth: 100,
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'status',
    headerName: 'Status',
    minWidth: 150,
    cellRenderer: 'statusCellRenderer',
    comparator: noOpComparator,
    filter: 'selectFilter',
    floatingFilter: true,
    floatingFilterComponent: 'selectFloatingFilter',
    floatingFilterComponentParams: {
      suppressFilterButton: true,
      options: [
        { label: 'In Underwriting', value: 'IN_UNDERWRITING' },
        { label: 'Agreed', value: 'AGREED' },
        { label: 'Pending', value: 'PENDING' },
        { label: 'Pending Decision', value: 'PENDING_DECISION' },
        { label: 'Pending Term Sheet', value: 'PENDING_TERM_SHEET' },
        { label: 'Prescreen', value: 'PRESCREEN' },
        { label: 'Term Sheet Out', value: 'TERM_SHEET_OUT' },
        { label: 'Unknown', value: 'UNKNOWN' },
        { label: 'Pre-Submission', value: 'PENDING_SUBMISSION' },
        { label: 'Deal Room', value: 'DEAL_ROOM' },
      ],
    },
  },
  {
    field: 'subStatus',
    headerName: 'Sub Status',
    minWidth: 240,
    cellRenderer: 'subStatusCellRenderer',
    comparator: noOpComparator,
    filter: 'selectFilter',
    floatingFilter: true,
    floatingFilterComponent: 'selectFloatingFilter',
    floatingFilterComponentParams: {
      suppressFilterButton: true,
      options: [
        { label: 'Data Entry No Appraisal', value: 'DATA_ENTRY_NO_APPRAISAL' },
        { label: 'Data Entry Appraisal', value: 'DATA_ENTRY_APPRAISAL' },
        { label: 'Structuring', value: 'STRUCTURING' },
        { label: 'In Underwriting', value: 'UNDERWRITING' },
        { label: 'Pending Decision', value: 'PENDING_DECISION' },
      ]
    },
  },
  {
    field: 'valuationReviewer',
    headerName: 'Valuation Specialist',
    minWidth: 250,
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'addressAndState',
    headerName: 'Address/State',
    minWidth: 300,
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'transactionType',
    headerName: 'Transaction Type',
    minWidth: 200,
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'queueStartDate',
    headerName: 'Queue Start Date',
    minWidth: 200,
    comparator: noOpComparator,
    filter: 'agDateColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'delay',
    headerName: 'Delay',
    minWidth: 200,
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'underwriter',
    headerName: 'Underwriter',
    minWidth: 200,
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'appraiserName',
    headerName: 'Appraiser',
    minWidth: 200,
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'appraisalDate',
    headerName: 'Appraisal Received Date',
    minWidth: 200,
    comparator: noOpComparator,
    filter: 'agDateColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'lenderName',
    headerName: 'Lender',
    minWidth: 250,
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'amount',
    headerName: 'Loan Amount',
    minWidth: 150,
    valueFormatter: usdAmount,
    comparator: noOpComparator,
  },
];

export const taskColumns: GridColumnProps[] = [
  {
    field: 'loanId',
    headerName: 'Loan Id',
    cellRenderer: 'loanIdCellRenderer',
    minWidth: 100,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'propertyAddress',
    headerName: 'Property Address',
    minWidth: 400,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'status',
    headerName: 'Status',
    minWidth: 125,
    maxWidth: 125,
    cellRenderer: 'statusCellRenderer',
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'assigneeNames',
    headerName: 'Assignee',
    minWidth: 200,
    cellRenderer: 'assigneeCellRenderer',
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'timeElapsed',
    headerName: 'Time Elapsed',
    cellRenderer: 'timeElapsedCellRenderer',
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
    minWidth: 100,
    maxWidth: 200,
  },
  {
    field: 'ownerName',
    headerName: 'Reporter',
    minWidth: 200,
    cellRenderer: 'assigneeCellRenderer',
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'priority',
    headerName: 'Priority',
    maxWidth: 120,
    cellRenderer: 'priorityCellRenderer',
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'createdDate',
    headerName: 'Created Date',
    minWidth: 220,
  },
  {
    field: 'lastUpdatedDate',
    headerName: 'Last Updated Date',
    minWidth: 220,
  }
];

export const disputeAppraisalColumns: GridColumnProps[] = [
  {
    field: 'loanId',
    headerName: 'Loan ID',
    cellRenderer: 'loanIdCellRenderer',
    minWidth: 100,
    maxWidth: 120,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: { suppressFilterButton: true },
  },
  {
    field: 'taskCode',
    headerName: 'Dispute Type',
    minWidth: 150,
    valueFormatter: params =>
      params.value === DISPUTE_TASK_CODE_INTERNAL_ROV
        ? 'Internal Dispute'
        : params.value === DISPUTE_TASK_CODE_CLIENT
          ? 'Client Dispute'
          : '',
    filter: 'selectFilter',
    floatingFilter: true,
    floatingFilterComponent: 'selectFloatingFilter',
    floatingFilterComponentParams: {
      suppressFilterButton: true,
      options: [
        { label: 'Internal Dispute', value: DISPUTE_TASK_CODE_INTERNAL_ROV },
        { label: 'Client Dispute', value: DISPUTE_TASK_CODE_CLIENT },
      ],
    },
  },
  {
    field: 'product',
    headerName: 'Product',
    minWidth: 160,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: { suppressFilterButton: true },
  },
  {
    field: 'realVal',
    headerName: 'RealVal',
    minWidth: 90,
    maxWidth: 100,
    valueFormatter: params => params.value ? 'Yes' : 'No',
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: { suppressFilterButton: true },
  },
  {
    field: 'assignedTo',
    headerName: 'Assigned To',
    minWidth: 150,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: { suppressFilterButton: true },
  },
  {
    field: 'loanSubStatus',
    headerName: 'Loan Substatus',
    minWidth: 220,
    cellRenderer: 'subStatusCellRenderer',
    comparator: noOpComparator,
    filter: 'selectFilter',
    floatingFilter: true,
    floatingFilterComponent: 'selectFloatingFilter',
    floatingFilterComponentParams: {
      suppressFilterButton: true,
      options: [
        { label: 'Data Entry No Appraisal', value: 'Data Entry No Appraisal' },
        { label: 'Data Entry Appraisal', value: 'Data Entry Appraisal' },
        { label: 'Structuring', value: 'Structuring' },
        { label: 'In Underwriting', value: 'In Underwriting' },
        { label: 'Pending Decision', value: 'Pending Decision' },
      ],
    },
  },
  {
    field: 'lastUpdated',
    headerName: 'Last Updated',
    minWidth: 180,
    filter: 'agDateColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: { suppressFilterButton: true },
    valueFormatter: params => params.value ? new Date(params.value).toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' }) : '',
  },
  {
    field: 'disputeSource',
    headerName: 'Dispute Source',
    minWidth: 130,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: { suppressFilterButton: true },
  },
  {
    field: 'appraisedValue',
    headerName: 'Appraised Value',
    minWidth: 140,
    valueFormatter: usdAmount,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: { suppressFilterButton: true },
  },
  {
    field: 'secondAppraisalValue',
    headerName: 'Second Appraisal Value',
    minWidth: 175,
    valueFormatter: usdAmount,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: { suppressFilterButton: true },
  },
  {
    field: 'internalValuation',
    headerName: 'Internal Valuation',
    minWidth: 155,
    valueFormatter: usdAmount,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: { suppressFilterButton: true },
  },
  {
    field: 'variancePercent',
    headerName: 'Variance %',
    minWidth: 115,
    valueFormatter: params => params.value != null ? `${params.value}%` : '',
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: { suppressFilterButton: true },
  },
  {
    field: 'arltv',
    headerName: 'ARLTV',
    minWidth: 100,
    valueFormatter: params => params.value != null ? `${params.value}%` : '',
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: { suppressFilterButton: true },
  },
];
